import { jsxs as c, jsx as s } from "react/jsx-runtime";
import { a as o } from "../../strings-Bu8_UcAh.js";
import { c as l } from "../../clsx-OuTLNxxd.js";
import { Tag as i } from "../../Tag/Tag.js";
const n = "ShorexDrawerTags-module_tags__lWk7W",
  d = "ShorexDrawerTags-module_tag__4wj7h",
  _ = "ShorexDrawerTags-module_new-tag__g-Kyk",
  m = "ShorexDrawerTags-module_sub-category__fkhOd",
  h = "ShorexDrawerTags-module_tag-classic__8WqMM",
  x = "ShorexDrawerTags-module_tag-expedition__MW7mK",
  a = {
    tags: n,
    tag: d,
    newTag: _,
    subCategory: m,
    tagClassic: h,
    tagExpedition: x
  },
  S = _ref => {
    let {
      newLabel: t,
      mainCategory: r,
      subCategory: e,
      cruiseType: g
    } = _ref;
    return o(t) || o(r) || o(e) ? /* @__PURE__ */c("ol", {
      className: a.tags,
      children: [t && /* @__PURE__ */s("li", {
        className: l(a.tag, a.newTag),
        children: /* @__PURE__ */s(i, {
          backgroundColor: "neutral15",
          children: t
        })
      }), r && /* @__PURE__ */s("li", {
        className: a.tag,
        children: r
      }), e && /* @__PURE__ */s("li", {
        className: l(a.tag, a.subCategory, {
          [a.tagClassic]: g === "classic",
          [a.tagExpedition]: g === "expedition"
        }),
        children: e
      })]
    }) : null;
  };
export { S as ShorexDrawerTags };